"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.withMasterDetail = withMasterDetail;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _navigationNext = require("@atlaskit/navigation-next");
var _styles = require("@material-ui/styles");
var _ModalView = require("../View/ModalView/ModalView");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    topLevelContainer: {
      // Fix double scrollbars when rendering a search list
      '& .css-11f6q49': {
        overflowY: 'hidden !important'
      },
      // Account for navbar height in fixed content section, so scrollbars don't
      // extend off the end of the screen
      //
      // LayoutContainer
      '&>div:first-child': (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
        height: function height(_ref) {
          var modalViewContext = _ref.modalViewContext;
          return modalViewContext ? "calc(100vh - ".concat(theme.functions.toRem(theme.variables.modalTop + theme.variables.modalMobilePadding + theme.variables.button), ")") : "calc(100vh - ".concat(theme.functions.toRem(theme.variables.navHeight), ")");
        }
      }, theme.breakpoints.desktop, {
        height: function height(_ref2) {
          var modalViewContext = _ref2.modalViewContext;
          return modalViewContext ? "calc(100vh - ".concat(theme.functions.toRem(theme.variables.modalTop + theme.variables.modalDesktopPadding + theme.variables.button), ")") : "calc(100vh - ".concat(theme.functions.toRem(theme.variables.navHeight), ")");
        }
      }), '&>div:nth-child(1)', {
        flex: '0 1 20rem',
        minWidth: '20rem',
        position: 'absolute',
        marginLeft: '1rem'
      }), '&>div:nth-child(2)', {
        flex: '1 1 auto',
        marginLeft: function marginLeft(_ref3) {
          var modalViewContext = _ref3.modalViewContext;
          return modalViewContext ? '1rem' : 0;
        }
      })
    }
  };
});

/*
 * `withMasterDetail`
 *
 * Usage:
 *
 *   const MyMasterDetailComponent withMasterDetail(MyComponent); // injects `navigationViewController`
 *
 *   const MyComponent = ({ navigationViewController }) => {
 *     // Call navigationViewController methods to control what appears in the master (left) nav pane
 *     navigationViewController.addView({ ... })
 *     navigationViewController.setView();
 *
 *     // The nodes returned here will appear in the detail (right) pane
 *     return <div>{...}</div>;
 *   }
 *
 *
 * Master Detail implementation requirements:
 *   - AtlaskitProviders must be rendered higher up the DOM tree than `withNavigationViewController` (or alternatively `ViewControllerSubscriber`)
 *   - Make `navigationViewController` prop available to web app consumer
 *
 * Reference:
 *   - View state controllers: https://atlaskit.atlassian.com/packages/core/navigation-next/docs/state-controllers#view-controller
 *
 * Note: This doesn't necessarily have to be an HOC.
 */

// 'product' is that Atlaskit navigation type that most closely meets the needs of our design:
// https://atlaskit.atlassian.com/packages/core/navigation-next/docs/controlling-navigation-views#managing-the-navigation-state
/*:: type MasterDetailNavigationType = 'product';*/
/*:: type NavigationViewController = {
  addView: ({
    id: string,
    type: MasterDetailNavigationType,
    getItems: (...args: Array<any>) => Array<Object> | Promise<Array<Object>>
  }) => void,
  setView: (id?: string) => void
};*/
// See Atlaskit documentation for a more complete description of NavigationViewController:
// https://atlaskit.atlassian.com/packages/core/navigation-next/docs/state-controllers
/*:: export type MasterDetailInjectedProps = {|
  navigationViewController: NavigationViewController
|};*/
// Flow HOC annotation reference: https://flow.org/en/docs/react/hoc/#toc-injecting-props
function withMasterDetail /*:: <Config>*/(WrappedComponent
/*: React.AbstractComponent<{|
    ...Config,
    ...MasterDetailInjectedProps
  |}>*/
) /*: React.AbstractComponent<Config>*/{
  return (0, _navigationNext.withNavigationViewController)(function MasterDetail(props /*: Config*/) {
    var modalViewContext = React.useContext(_ModalView.ModalViewContext);
    var classes = useStyles({
      modalViewContext: modalViewContext
    });
    return /*#__PURE__*/React.createElement("div", {
      className: classes.topLevelContainer
    }, /*#__PURE__*/React.createElement(_navigationNext.LayoutManagerWithViewController, {
      globalNavigation: function globalNavigation() {
        return null;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.detailContainer
    }, /*#__PURE__*/React.createElement(WrappedComponent, props))));
  });
}
var _default = exports.default = withMasterDetail;
//# sourceMappingURL=MasterDetail.js.map